<template>
  <div class="dashboard-box">
    <h2>Previous Financing:</h2>
    <div v-show="editable" class="text-muted margin-bottom-20">
      {{ helpMessages.previousRaising }}
    </div>

    <overview-timeline-round
      v-for="(round, idx) in previousRounds"
      :key="round.id"
      :ref="`round_${round.id}`"
      :editable="editable"
      :round="round"
      :round-errors="getRoundErrors(idx)"
      :idx="idx"
      @yearChange="onYearChange"
    />

    <div v-if="editable">
      <br />
      <button
        class="btn btn-default btn-transparent"
        @click="addBlankPreviousRound()"
      >
        Add previous round
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import OverviewTimelineRound from './OverviewTimelineRound.vue'
import helpMessages from './helpMessages'
import { uuid4 } from '@/utils'

export default {
  components: { OverviewTimelineRound },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      startup: (state) => state.startupProfile.startup,
      apiErrors: (state) => state.startupProfile.errors,
    }),
    ...mapGetters({
      previousRounds: 'startupProfile/previousRounds',
    }),
    helpMessages() {
      return helpMessages
    },
  },
  methods: {
    addBlankPreviousRound() {
      const round = {
        id: uuid4(),
        size: null,
        type: null,
        securities: [],
        sources: [],
        investor: '',
        year: null,
      }
      this.addPreviousRound(round)
    },
    addPreviousRound(round) {
      const previousRounds = (this.previousRounds || []).concat(round)
      this.setPreviousRounds(previousRounds)
    },
    setPreviousRounds(rounds) {
      this.$store.commit('startupProfile/SET_STARTUP_ATTR', {
        attr: 'previous_rounds',
        value: rounds,
      })
    },
    getRoundErrors(idx) {
      const roundErrors = {
        date: [],
        size: [],
      }
      if (
        this.apiErrors.previous_rounds &&
        this.apiErrors.previous_rounds[idx]
      ) {
        Object.assign(roundErrors, this.apiErrors.previous_rounds[idx])
        return roundErrors
      } else {
        return roundErrors
      }
    },
    scrollElementIntoView(element) {
      const yOffset = -80
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    },
    onYearChange(round, newYear) {
      this.$nextTick(() => {
        const roundRef = this.$refs[`round_${round.id}`][0]

        if (roundRef && roundRef.$el) {
          const xPath = `//div[contains(text(),'${newYear}')]`
          const matchingElement = document.evaluate(
            xPath,
            document,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null,
          ).singleNodeValue

          this.scrollElementIntoView(matchingElement)
        }
      })
    },
  },
}
</script>
